"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentRow = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var grid_1 = require("antd/es/grid");

exports.ContentRow = function (_a) {
  var leftSlot = _a.leftSlot,
      rightSlot = _a.rightSlot,
      rowProps = tslib_1.__rest(_a, ["leftSlot", "rightSlot"]);

  return React.createElement(grid_1.Row, Object.assign({
    type: 'flex',
    align: 'middle'
  }, rowProps), React.createElement(grid_1.Col, {
    span: 12
  }, leftSlot), React.createElement(grid_1.Col, {
    span: 12
  }, rightSlot));
};